/* eslint-disable @typescript-eslint/no-explicit-any */
import { Organization, OrganizationPagination } from 'model/organization';

export interface OrganizationState {
    status: OrganizationStatus;
    loading: boolean;
    error?: string;
    savedOrganization?: any;
    organizations: Array<Organization>;
    pagination?: OrganizationPagination;
}

export enum OrganizationStatus {
    // eslint-disable-next-line no-unused-vars
    Initial,
    // eslint-disable-next-line no-unused-vars
    Error,
    // eslint-disable-next-line no-unused-vars
    Fetching,
    // eslint-disable-next-line no-unused-vars
    FetchSuccess,
    // eslint-disable-next-line no-unused-vars
    Saving,
    // eslint-disable-next-line no-unused-vars
    SaveSuccess,
    // eslint-disable-next-line no-unused-vars
    Deleting,
    // eslint-disable-next-line no-unused-vars
    DeleteSuccess
}
